import { cloneDeep } from 'lodash-es';
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostBinding,
    OnDestroy,
    OnInit,
    Output,
    ViewRef
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import {
    EcapCorporateIdentityService,
    EcapLoginService,
    EcapTranslateService,
    getCurrentLanguage,
    LanguageAction,
    NotificationService,
    ShellDomainProvider,
    State,
    UserInfoService
} from '../../../shared/standalone-packages/ecap3/core';
import { SignalrNotificationService } from '../../../shared/standalone-packages/ecap3/signalr-notification';
import {
    EcapBroadcastService,
    FuseConfigService,
    FuseMatSidenavHelperService,
    TemplateAtlasSharedService,
    ToolbarTriggerService
} from '../../../shared/standalone-packages/ecap3/template-atlas';
// import { LADERACH_CONFIG } from '../../laderach-config/constant/laderach-config.constant';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { AuthorizeMailRedirectService } from '../../../shared/services/authorize-mail-redirect.service';
import { EcapUser } from '../../../app-user-management/model/user-access-management.model';
import { AppUserManagementService } from '../../../app-user-management/service/app-user-management.service';
import { MailAuthStatusService } from '../../../shared/services/mail-auth-status.service';
import { CommonService } from './../../../shared/services/common.service';
import { CaseViewRoutingService } from '../../../shared/services/case-view-routing.service';
import { SCConfig } from '../../../sc-config/constant/sc-config.constant';
import { PlatfromUserAccssManagementService } from '../../../shared/standalone-packages/ecap3/app-platform-user-access-management';
import { DeleteModalComponent } from '../../../shared/components/delete-modal/delete-modal.component';
import { AppNotificationService } from '../../../shared/services/app-notification.service';
import { QueryHandlerResponse } from '../../../shared/models/responseModels/QueryHandlerResponse';
import { ApplicationNotification } from '../../models/application-notification.model';
import { UserActivityService } from '../../../shared/services/user-activity.service';
import { PCXConstants } from '../../../sc-config/constant/PCXConstants';
import { IpexFileService } from '../../../shared/services/ipex-file.service';
import { BusinessService } from '../../../shared/services/business.service';
import { TitleService } from '../../service/title.service';
import { CaseDefaultsService } from '../../../app-create-case/services/case-defaults.service';
import { SideNavigationClickService } from '../../../shared/standalone-packages/ecap3/template-atlas/@fuse/components/navigation/side-navigation-click.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class SCPCXToolbarComponent implements OnInit, OnDestroy {
    @HostBinding('class.is-preview-open') isPreviewOpen;
    @HostBinding('class.is-preview-close') isPreviewClose;

    usersOrgLogo = ShellDomainProvider['api'].SiteLogo;
    @Output() emitter = new EventEmitter<any>();
    userStatusOptions: any[];
    isDarkMode: boolean = false;
    currentView: string = 'new';

    showLoadingBar: boolean;
    horizontalNav: boolean;
    newNotificationUpdate = new EventEmitter<any>();
    subscription: any;
    subscribeNewNotification: Subscription;
    subscriptionMarkRead: Subscription;
    newNotificationArrived: boolean;
    language = new Subject<string>();
    lang$: Observable<string>;
    languages: any;
    selectedLanguage: any;
    userInfo: EcapUser;
    clientName: string;
    // checking if new notification arrived
    webUrl: string;
    emailAuthorized: boolean = false;
    emailNotAuthorizedBox: boolean = false;
    emailAuthorizedBox: boolean = false;
    currentRole: string;
    recievedAuthStatusReponse: boolean = false;
    private destroy$: Subject<boolean> = new Subject<boolean>();
    currentUserRole: any = SCConfig.CurrentRole;
    applicationNotifications: ApplicationNotification[] = [];
    totalUnreadMessage: number = 0;
    isShowEmailAuthTick: boolean | null = null;
    fethcmailAuthStatusResponseCount: number = 0;
    previousLanguage: string = ''; // Store previous language before switching to key mode
    private keymodeEventListener: (event: MessageEvent) => void;
    isSystemAdmin : boolean = false;
    constructor(
        // private toolbarService: ToolbarService,
        // private sharedDataService: Share,
        // public commonService: CommonService,
        // private clientService: ClientService,
        private router: Router,
        private matSnackbar: MatSnackBar,
        private fuseConfig: FuseConfigService,
        private loginService: EcapLoginService,
        public toolbarTriggerService: ToolbarTriggerService,
        private translateService: TranslateService,
        private ecapTranslateService: EcapTranslateService,
        private cdRef: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private ecapCorporateIdentityService: EcapCorporateIdentityService,
        private signalrNotificationService: SignalrNotificationService,
        private notificationService: NotificationService,
        public sharedService: TemplateAtlasSharedService,
        private userInfoService: UserInfoService,
        private userManagementService: AppUserManagementService,
        private matSidebarHelper: FuseMatSidenavHelperService,
        private changeDetection: ChangeDetectorRef,
        private store: Store<State>,
        private ecapBroadcastService: EcapBroadcastService,
        private platfromUserAccssManagementService: PlatfromUserAccssManagementService,
        private emailRedirect: AuthorizeMailRedirectService,
        public mailAuthStatusService: MailAuthStatusService,
        private commonService: CommonService,
        private cdrf: ChangeDetectorRef,
        private mailRedirectService: AuthorizeMailRedirectService,
        private userActivityService: UserActivityService,
        private readonly ipexFileService: IpexFileService,
        private businessService: BusinessService,
        private titleService: TitleService,
        private caseDefaultsService: CaseDefaultsService,
        private caseViewRoutingService: CaseViewRoutingService,
        private sideNavigationClickService: SideNavigationClickService
    ) {
        this.lang$ = this.store.pipe(select(getCurrentLanguage));

        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages =
            ShellDomainProvider['api'] && ShellDomainProvider['api']['language']
                ? ShellDomainProvider['api']['language']
                : null;

        this.selectedLanguage = this.languages[0];

        router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
            if (event instanceof NavigationStart) {
                this.showLoadingBar = true;
            }
            if (event instanceof NavigationEnd) {
                this.showLoadingBar = false;
            }
        });

        this.userInfo = this.userInfoService.getUserInfo();
        this.userInfo = cloneDeep(this.userInfo);
        this.userInfoService
            .getUserInfoEvent()
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
                this.userInfo = cloneDeep(data);
            });

        // this.fuseConfig.onSettingsChanged.subscribe((settings) => {
        //     this.horizontalNav = settings.layout.navigation === 'top';
        // });

        // =====================================================
        // subscribing for new notification counter
        // =====================================================
        this.newNotificationUpdate.pipe(takeUntil(this.destroy$)).subscribe(counter => {
            this.sharedService.notifyNewUnreadMessage(0, 10, true);
            // this.numberOfUnreadMessage = counter;
            this.updateCounter(counter);
            if (!(<ViewRef>this.changeDetection).destroyed) {
                this.changeDetection.detectChanges(); // important feature for live update of chat field : this is must
            }
        });
        // ======================================================
        // update counter after notification marked as read
        // ======================================================
        this.subscriptionMarkRead = this.sharedService.notificationMarkRead
            .pipe(takeUntil(this.destroy$))
            .subscribe((result: any) => {
                // this.numberOfUnreadMessage = result;
                this.updateCounter(result);
                if (!(<ViewRef>this.changeDetection).destroyed) {
                    this.changeDetection.detectChanges(); // important feature for live update of chat field : this is must
                }
            });
        // ================================================
        // signalrNotification integration
        // ================================================

        // storing references for using inside signalr callback function
        const notification = this.notificationService;
        const newNotificationUpdate = this.newNotificationUpdate;
        const replicaSharedService = this.sharedService;
        // storing references for using inside signalr callback function ends
        // chatting related notification

        this.signalrNotificationService['hubConnectionEstablished']
            .pipe(takeUntil(this.destroy$))
            .subscribe(hubConnected => {
                if (hubConnected) {
                }
            });
        // ================================================
        // signalrNotification integration ends
        // ================================================

        // ===============================================
        // getting all unread notifications on first load
        // ===============================================
        this.getAllUnreadNotificationOnInitialLoad();
        // ===============================================
        // when new notification arrives
        // ===============================================
        this.sharedService.newNotificationArrived.pipe(takeUntil(this.destroy$)).subscribe(response => {
            this.newNotificationArrived = response;
            setTimeout(() => {
                this.newNotificationArrived = false; // resetting again for next use
                if (!(<ViewRef>this.changeDetection).destroyed) {
                    this.changeDetection.detectChanges(); // important feature for live update of chat field : this is must
                }
            }, 500);
        });
        this.titleService.isProfileUpdate.pipe(takeUntil(this.destroy$)).subscribe(isUpdated => {
            if (isUpdated) {
                this.getPersonDetailsByUserId();
            }
        });
    }

    ngOnInit(): void {
        this.currentView = this.caseViewRoutingService.getViewPreference();

        TemplateAtlasSharedService.getChangePreview()
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
                this.isPreviewOpen = data;
            });

        this.lang$.pipe(takeUntil(this.destroy$)).subscribe(lang => {
            this.selectedLanguage = lang;
            this.translateService.use(lang);
        });
        this.currentRole = this.commonService.getCurrentRoleUser();
        this.language.pipe(takeUntil(this.destroy$)).subscribe(lang => {
            this.store.dispatch(new LanguageAction(lang));
            this.selectedLanguage = lang;
        });
        this.logoutFromAllTab();
        this.cdRef.detectChanges();
        this.detectChange();

        this.ecapBroadcastService
            .onUserInfoEvent()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                userInfo => {
                    // this.loadProfileImage();
                    this.mailAuthStatusService.currentUserEmail = userInfo.Email;
                    this.mailAuthStatusService.currentUsername = userInfo.DisplayName;
                    this.processUserLoginForEmailAuth();
                    if(userInfo.Roles.includes('system_admin') || userInfo.Roles.includes('admin')) {
                        this.isSystemAdmin = true;
                    }
                },
                error => {
                    console.error('ToolbarComponent.onUserInfoEvent() received an error. NOT logging out.', error);
                }
            );
        this.applyDarkMode();

        // Subscribe to periodic updates every 10 minutes
        this.userActivityService.periodicActiveTime$.pipe(takeUntil(this.destroy$)).subscribe(activeTime => {
            this.updatePersonLastActiveTime();
        });

        // Setup keymode event listener for Chrome extension
        this.uilmKeyValueModeEventListener();
    }

    private uilmKeyValueModeEventListener() {
        this.keymodeEventListener = (event: MessageEvent) => {
            let doNotReload = true;
            if (event.source !== window) return; // Ignore messages from iframes or other sources
            if (event.origin !== window.location.origin) return; // Prevent cross-origin injections
            const { data } = event;
            if (!data || typeof data !== 'object') return;

            // Early exit if this is not a keymode action - improves performance
            const { action, keymode, defaultLang } = data as {
                action?: string;
                keymode?: boolean;
                defaultLang?: string;
            };
            if (action !== 'keymode') return;

            // Only log and process if it's actually a keymode message
            console.log('Keymode event received:', { action, keymode, defaultLang });
            const defaultLangId = defaultLang ? defaultLang.split('-')[0] : 'de-DE';

            if (typeof keymode === 'boolean') {
                if (keymode) {
                    // Store current language before switching to key mode
                    if (this.selectedLanguage !== PCXConstants.UILM_KEY_MODE_KEY) {
                        this.previousLanguage = this.selectedLanguage;
                    }
                    console.log('Switching to KEY mode. Previous language:', this.previousLanguage);
                    if (!(this.selectedLanguage === PCXConstants.UILM_KEY_MODE_KEY && keymode)) {
                        this.changeLang(PCXConstants.UILM_KEY_MODE_KEY);
                        doNotReload = false;
                    }
                } else {
                    // Restore previous language or use defaultLang
                    const languageToRestore = this.previousLanguage || defaultLangId || 'en-US';
                    if (this.previousLanguage === PCXConstants.UILM_KEY_MODE_KEY) {
                        this.previousLanguage = 'en-US';
                    }
                    console.log('Switching back to value mode. Restoring language:', languageToRestore);
                    this.changeLang(languageToRestore);
                    doNotReload = true;
                }
                if (!doNotReload) window.location.reload();
            }
        };
        window.addEventListener('message', this.keymodeEventListener);
    }

    private processUserLoginForEmailAuth() {
        this.userInfoService.currentUserData.pipe(takeUntil(this.destroy$)).subscribe(response => {
            const currentUser = this.userInfoService.getUserInfo();
            this.getPersonDetailsByUserId();
            if (response.isLoggedIn === 'True' && currentUser?.UserId && this.fethcmailAuthStatusResponseCount === 0) {
                this.fethcmailAuthStatus(currentUser.UserId);
                this.fethcmailAuthStatusResponseCount++;
            } else if (
                response &&
                response === 'DEFAULT_MESSAGE' &&
                this.fethcmailAuthStatusResponseCount === 0 &&
                currentUser?.UserId
            ) {
                this.fethcmailAuthStatus(currentUser?.UserId);
                this.fethcmailAuthStatusResponseCount++;
            }
        });
    }

    private fethcmailAuthStatus(userId: string) {
        this.mailAuthStatusService
            .getEmailAuthStatus(userId)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                response => {
                    if (response.Results['AuthorizationStatus']) {
                        this.mailAuthStatusService.isMailAuthorized = true;
                    } else {
                        this.mailAuthStatusService.isMailAuthorized = false;
                    }

                    this.isShowEmailAuthTick = true;
                    this.recievedAuthStatusReponse = true;
                },
                error => {
                    this.mailAuthStatusService.isMailAuthorized = false;
                }
            );
    }

    getProfilePicture(userInfo) {
        this.userInfo.ProfileImage = null; // removing current profile image url, if any
        if (!userInfo || !userInfo.ProfileImageId) return;

        this.ipexFileService
            .getFileUrlById(userInfo.ProfileImageId, null, SCConfig.ImageSize.THUMBNAIL)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: res => {
                    if (res) {
                        this.userInfo['ProfileImage'] = res;
                    }
                },
                error: err => console.error('Failed to get profile picture', err)
            });
    }

    updateCounter(counter) {
        this.sharedService.setCounter(counter); // then setting counter to actual number
    }

    public logout() {
        console.warn(
            'Logout triggered: ToolbarComponent.logout() called (typically via user clicking the logout button).'
        );
        const that = this;
        this.loginService.logoutFromPlatform();
        this.loginService.clearExistingRefreshToken();

        localStorage.removeItem('logged-in-this-platform');
        // this.featureProvider.resetFeatures();
        // this.router.navigate([`/`]);
    }

    public changeLang(langKey) {
        let prevLanguage = this.selectedLanguage;
        this.language.next(langKey);
        this.selectedLanguage = langKey;
        this.setLangCookie(langKey);
        this.ecapTranslateService.changeLanguage(langKey);
        if (prevLanguage === PCXConstants.UILM_KEY_MODE_KEY && prevLanguage !== langKey) {
            window.location.reload();
        }
    }

    public setLangCookie(lang) {
        document.cookie = `langKey=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        document.cookie = `langKey=${lang}; Path=/`;
    }

    /**
     * Title: getAllUnreadNotificationOnInitialLoad
     * Description: getting all unread notifications on initial load
     */
    getAllUnreadNotificationOnInitialLoad(): void {
        this.subscription = this.userInfoService.currentUser.pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
            if (result !== 'DEFAULT_MESSAGE') {
                this.notificationService
                    .getUnreadNotificationCounter()
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(counter => {
                        this.newNotificationUpdate.emit(counter);
                    });
            }
        });
    }

    public clickOnProfile(): void {
        this.sideNavigationClickService.setSideNavigationClicked({
            isClicked: true,
            url: 'profile'
        });

        setTimeout(() => {
            this.sideNavigationClickService.setSideNavigationClicked({
                isClicked: false,
                url: 'profile'
            });
        }, 100);
    }

    private detectChange() {
        this.cdRef.markForCheck();
        setTimeout(() => {
            if (this.cdRef !== null && this.cdRef !== undefined && !(this.cdRef as ViewRef).destroyed) {
                this.cdRef.detectChanges();
            }
        }, 250);
    }

    // TODO: Remove this function, the condition if never works
    // private loadProfileImage(): void {
    //     this.userManagementService
    //         .getPersonByUserId(this.userInfo.UserId)
    //         .pipe(takeUntil(this.destroy$))
    //         .subscribe(personInfo => {
    //             if (personInfo && personInfo.ProfileImage) {
    //                 const fileId = personInfo.ProfileImageId.FileId;
    //                 this.ipexFileService
    //                     .getFileUrlById(fileId)
    //                     .pipe(takeUntil(this.destroy$))
    //                     .subscribe({
    //                         next: response => {
    //                             if (response) {
    //                                 this.platfromUserAccssManagementService
    //                                     .getUserInfoById(this.userInfo.UserId)
    //                                     .pipe(takeUntil(this.destroy$))
    //                                     .subscribe(user => {
    //                                         user['ProfileImage'] = response;
    //                                     });
    //                             }
    //                         },
    //                         error: err => console.error('Failed to get profile picture', err)
    //                     });
    //             }
    //         });
    // }

    openNotAuthorizedTooltip() {
        this.emailNotAuthorizedBox = !this.emailNotAuthorizedBox;
        if (this.emailNotAuthorizedBox) {
            setTimeout(() => {
                this.emailNotAuthorizedBox = false;
            }, 4000);
        }
    }
    // Experimental Dark mode code starts
    toggleDarkMode() {
        this.isDarkMode = !JSON.parse(localStorage.getItem('darkMode'));
        localStorage.setItem('darkMode', JSON.stringify(this.isDarkMode));
        this.applyDarkMode();
    }
    applyDarkMode() {
        this.isDarkMode = JSON.parse(localStorage.getItem('darkMode'));
        // Toggle the 'dark-mode' class on the body element
        if (this.isDarkMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }
    // Experimental Dark mode code ends

    openAuthorizedTooltip() {
        this.emailAuthorizedBox = !this.emailAuthorizedBox;
        if (this.emailAuthorizedBox) {
            setTimeout(() => {
                this.emailAuthorizedBox = false;
            }, 2000);
        }
    }
    onRedirect() {
        let Url: string;
        this.emailRedirect
            .getRedirectUrlForCurrentUser()
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                Url = JSON.parse(response.Results).Url;
                window.open(Url);
                this.emailAuthorized = true;
            });
    }

    openAutomationReport() {
        const automationReportUrl = window.location.origin + '/automation-report';
        window.open(automationReportUrl, '_blank');
    }

    logoutFromAllTab() {
        window.addEventListener('storage', event => {
            // Only react when 'logged-in-this-platform' is specifically and explicitly removed.
            // The old code fired on ANY localStorage change and checked if the key was absent,
            // which caused false logouts for SSO users during cross-tab/cross-domain activity.
            if (event.key === 'logged-in-this-platform' && event.newValue === null && event.oldValue !== null) {
                console.warn(
                    'Logout triggered: ToolbarComponent.logoutFromAllTab() – logged-in-this-platform was explicitly removed from another tab.'
                );
                this.loginService.logoutFromPlatform();
                this.loginService.clearExistingRefreshToken();
            }
        });
    }

    // on component destroy setting counter to zero
    ngOnDestroy(): void {
        this.sharedService.setCounter(0);
        if (this.subscribeNewNotification) {
            this.subscribeNewNotification.unsubscribe();
        }
        if (this.subscriptionMarkRead) {
            this.subscriptionMarkRead.unsubscribe();
        }

        // this.mailRedirectService.redirectPopupDone.next(false);
        this.destroy$.next(true);
        this.destroy$.complete();
        this.resetAuthorizedTick();

        // Remove keymode event listener
        if (this.keymodeEventListener) {
            window.removeEventListener('message', this.keymodeEventListener);
        }
    }

    private resetAuthorizedTick() {
        this.mailAuthStatusService.isMailAuthorized = null;
        this.isShowEmailAuthTick = null;
        this.fethcmailAuthStatusResponseCount = 0;
    }

    updateApplicationNotifications(applicationNotifications: ApplicationNotification[]) {
        this.applicationNotifications = applicationNotifications;
        const listOfUnreadMessage = applicationNotifications.filter(notification => !notification.IsRead);
        this.totalUnreadMessage = 0;
        if (listOfUnreadMessage.length > 0) {
            this.totalUnreadMessage = listOfUnreadMessage.length;
        }
    }

    private updatePersonLastActiveTime() {
        this.userActivityService
            .updatePersonLastActiveTime()
            .pipe(takeUntil(this.destroy$))
            .subscribe(result => {});
    }
    private getPersonDetailsByUserId() {
        const currentUser = this.userInfoService.getUserInfo();
        if (currentUser === null) return;
        if (currentUser?.UserId) {
            this.caseDefaultsService
                .getUserByCreateBy(currentUser.UserId)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: response => {
                        if (response) {
                            this.userInfo['DisplayName'] = response.Data[0].DisplayName;
                            this.userInfo['ProfileImageId'] = response.Data[0].ProfileImageId;
                            this.getProfilePicture(this.userInfo);
                        }
                    },
                    error: err => console.error('Failed to get person details', err)
                });
        }
    }

    setViewPreference(view: 'classic' | 'new') {
        this.currentView = view;
        this.caseViewRoutingService.setViewPreference(view);
    }
}
